var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_11766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_11766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 21C12.9111 21 11.8708 21.1703 10.8792 21.511C9.8875 21.8509 8.98333 22.3611 8.16667 23.0417V23.3333H19.8333V23.0417C19.0167 22.3611 18.1125 21.8509 17.1208 21.511C16.1292 21.1703 15.0889 21 14 21ZM5.83333 21.9917C6.88333 20.9611 8.10367 20.1491 9.49433 19.5557C10.8842 18.963 12.3861 18.6667 14 18.6667C15.6139 18.6667 17.1162 18.963 18.5068 19.5557C19.8967 20.1491 21.1167 20.9611 22.1667 21.9917V7.00001H5.83333V21.9917ZM14 16.3333C12.8722 16.3333 11.9097 15.9347 11.1125 15.1375C10.3153 14.3403 9.91667 13.3778 9.91667 12.25C9.91667 11.1222 10.3153 10.1597 11.1125 9.36251C11.9097 8.56529 12.8722 8.16668 14 8.16668C15.1278 8.16668 16.0903 8.56529 16.8875 9.36251C17.6847 10.1597 18.0833 11.1222 18.0833 12.25C18.0833 13.3778 17.6847 14.3403 16.8875 15.1375C16.0903 15.9347 15.1278 16.3333 14 16.3333ZM14 14C14.4861 14 14.8991 13.8297 15.239 13.489C15.5797 13.1491 15.75 12.7361 15.75 12.25C15.75 11.7639 15.5797 11.3509 15.239 11.011C14.8991 10.6703 14.4861 10.5 14 10.5C13.5139 10.5 13.1009 10.6703 12.761 11.011C12.4203 11.3509 12.25 11.7639 12.25 12.25C12.25 12.7361 12.4203 13.1491 12.761 13.489C13.1009 13.8297 13.5139 14 14 14ZM5.83333 25.6667C5.19167 25.6667 4.64217 25.4384 4.18483 24.9818C3.72828 24.5245 3.5 23.975 3.5 23.3333V7.00001C3.5 6.35834 3.72828 5.80923 4.18483 5.35268C4.64217 4.89534 5.19167 4.66668 5.83333 4.66668H7V2.33334H9.33333V4.66668H18.6667V2.33334H21V4.66668H22.1667C22.8083 4.66668 23.3578 4.89534 23.8152 5.35268C24.2717 5.80923 24.5 6.35834 24.5 7.00001V23.3333C24.5 23.975 24.2717 24.5245 23.8152 24.9818C23.3578 25.4384 22.8083 25.6667 22.1667 25.6667H5.83333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpRequest);
export default __webpack_public_path__ + "static/media/IPRequest.70990f0c231808c9e6b28f82e85f9949.svg";
export { ForwardRef as ReactComponent };